import React, { useState, useCallback } from 'react';
import { string, func, bool } from 'prop-types';
import { debounce } from 'debounce';
import { ESC } from '../../../utils/constants/key_codes';

const SearchInput = ({ query, placeholderText, className, updateQuery, inputRef, onFocus, handleExit, disabled, readOnly }) => {
  const [shouldTrack, updateShouldTrack] = useState(true);
  const [currentQuery, updateCurrentQuery] = useState(query);

  const handleKeyUp = e => {
    e.preventDefault();

    if (e.keyCode === ESC) {
      handleExit();
    }
  };

  const doSearch = useCallback(
    debounce(q => {
      updateQuery(q);
    }, 500),
    []
  );

  const handleOnChange = e => {
    const q = e.currentTarget.value;

    updateCurrentQuery(q);
    doSearch(q);

    if (shouldTrack) {
      _gaq.push(['_trackEvent', 'Header Middle', 'Search Box', 'Search Box']);
      updateShouldTrack(false);
    }
  };

  return (
    <input
      ref={inputRef}
      value={currentQuery}
      disabled={disabled}
      onFocus={onFocus}
      aria-label={placeholderText}
      autoComplete="off"
      autoCorrect="off"
      data-test-id="algoliaPlaceholderText"
      onKeyUp={handleKeyUp}
      onChange={handleOnChange}
      type="text"
      className={className}
      placeholder={placeholderText}
      spellCheck="false"
      readOnly={readOnly}
    />
  );
};

SearchInput.propTypes = {
  query: string,
  toggleEngaged: func,
  placeholderText: string,
  className: string,
  updateQuery: func,
  disabled: bool,
  readOnly: bool
};

SearchInput.defaultProps = {
  query: string,
  toggleEngaged: () => {},
  placeholderText: '',
  className: '',
  updateQuery: () => {},
  disabled: false,
  readOnly: false
};

export default SearchInput;
